import getFilterWithCol from '../../helpers/getFilterWithCol';

import Types from '../../modules/types';

import { filterSortCreatedUpdatedName } from '../../components/common';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => {
    if (value?.length) {
      const valueRegex = Types.getSafeSearchRegex(value);
      builder.add(
        'where',
        {
          OR: ['name'].map(key => ({
            [key]: { REGEX: valueRegex, OPTIONS: 'i' },
          })),
        },
      );
    }
  },
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search by name',
  }],
}];

export const filterPopulate = ['FilterHidden', {
  id: 'populate',
  build: builder => builder.add('populate', {
    store: {
      _id: true,
      name: true,
    },
  }),
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const ADMIN = [
  ...[
    [filterSearch, 12],
    [filterSortCreatedUpdatedName, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),
  filterPopulate,
  filterPagination,
];
